import { quickSearchMobileScenarioA } from './quick-search-mobile-scenarios'
import {
  mobileScenarioA,
  mobileScenarioB,
  mobileScenarioC,
  mobileScenarioD,
  mobileScenarioE,
  mobileScenarioF,
  mobileScenarioG,
  mobileScenarioH,
  mobileScenarioI,
  mobileScenarioJ,
  mobileScenarioK,
  mobileScenarioL,
  mobileScenarioM,
  mobileScenarioN,
  mobileScenarioO,
  mobileScenarioP,
} from './mobile-scenarios'
import {
  internetScenarioA,
  internetScenarioB,
  internetScenarioC,
  internetScenarioD,
  internetScenarioE,
  internetScenarioF,
  internetScenarioG,
  internetScenarioH,
  internetScenarioI,
} from './internet-scenarios'
import {
  mobileReviewsScenarioA,
  internetReviewsScenarioA,
  mobileReviewsScenarioB,
  internetReviewsScenarioB,
  mobileReviewsScenarioC,
} from './reviews-scenarios'
import { ticketScenarioA } from './ticket-scenarios'
import { adviseInternetScenarioA } from './advise-internet-scenarios'
import { mobileSearchEmailScenarioA } from './mobile-search-email-scenarios'
import {
  leadMobileScenarioA,
  leadInternetScenarioA,
  leadMobileScenarioB,
  leadInternetScenarioB,
  leadInternetScenarioC,
  leadMobileScenarioC,
} from './lead-scenarios'
import { checkAvailabilityScenarioA } from './check-availability-scenarios'
import {
  mobileAlertScenarioA,
  internetAlertScenarioA,
  internetFiberOpticAlertScenarioA,
  internetFiberOpticAlertScenarioB,
  internetAlertObserverScenarioA,
  mobileAlertObserverScenarioA,
  internetAlertScenarioB,
  mobileAlertScenarioB,
} from './alert-scenarios'
import { competitionInternetAlertScenarioA } from './competition-alert-scenarios'
import { newsletterScenarioA } from './newsletter-scenarios'
import { decisionScenarioA, decisionAlertScenarioA, decisionReviewContestScenarioA } from './decision-scenarios'
import { ScenarioType } from '../state/interfaces'
import { getCookie, setCookie } from './storage'
import { internetSpeedScenarioA } from './internet-speed-scenarios'
import { canadaVisitorScenarioA } from './canada-visitor-scenarios'
import { emailPageGoInternetScenarioA } from './email-page-go-scenarios'
import { emailPageGoMobileScenarioA } from './email-page-go-scenarios'
import { b2bScenarioA, b2bScenarioB } from './b2b-scenarios'
import { countryScenarioA } from './country-scenarios'
import {
  internetReviewsAwardScenarioB,
  mobileReviewsAwardScenarioB,
  mobileReviewsAwardScenarioC,
} from './reviews-award-scenarios'
import { emailCollectorScenarioA } from './email-collector-scenarios'
import { phoneSearchScenarioA } from './phone-search-scenarios'

export const getAllScenarios = () => [
  mobileScenarioA,
  mobileScenarioB,
  mobileScenarioC,
  mobileScenarioD,
  mobileScenarioE,
  mobileScenarioF,
  mobileScenarioG,
  mobileScenarioH,
  mobileScenarioI,
  mobileScenarioJ,
  mobileScenarioK,
  mobileScenarioL,
  mobileScenarioM,
  mobileScenarioN,
  mobileScenarioO,
  mobileScenarioP,
  internetScenarioA,
  internetScenarioB,
  internetScenarioC,
  internetScenarioD,
  internetScenarioE,
  internetScenarioF,
  internetScenarioG,
  internetScenarioH,
  internetScenarioI,
  mobileReviewsScenarioA,
  internetReviewsScenarioA,
  mobileReviewsScenarioB,
  mobileReviewsScenarioC,
  internetReviewsScenarioB,
  leadMobileScenarioA,
  leadInternetScenarioA,
  leadMobileScenarioB,
  leadInternetScenarioB,
  leadInternetScenarioC,
  leadMobileScenarioC,
  checkAvailabilityScenarioA,
  mobileAlertScenarioA,
  mobileAlertScenarioB,
  internetAlertScenarioA,
  internetAlertScenarioB,
  internetAlertObserverScenarioA,
  mobileAlertObserverScenarioA,
  internetFiberOpticAlertScenarioA,
  internetFiberOpticAlertScenarioB,
  competitionInternetAlertScenarioA,
  mobileSearchEmailScenarioA,
  adviseInternetScenarioA,
  newsletterScenarioA,
  decisionScenarioA,
  decisionAlertScenarioA,
  decisionReviewContestScenarioA,
  quickSearchMobileScenarioA,
  ticketScenarioA,
  internetSpeedScenarioA,
  canadaVisitorScenarioA,
  emailPageGoInternetScenarioA,
  emailPageGoMobileScenarioA,
  b2bScenarioA,
  b2bScenarioB,
  countryScenarioA,
  mobileReviewsAwardScenarioB,
  mobileReviewsAwardScenarioC,
  internetReviewsAwardScenarioB,
  emailCollectorScenarioA,
  phoneSearchScenarioA,
]

export const findScenarioById = (scenarioId: string) =>
  getAllScenarios().find((scenario) => scenario.id === scenarioId && scenario.weight !== 0)

export const chooseScenarioId = (scenarioIdsToChooseFrom: Array<string>): string => {
  const scenarioIdCopies: Array<string> = []
  scenarioIdsToChooseFrom.forEach((scenarioId) => {
    const defaultWeight = 1
    const scenarioIdWeight = findScenarioById(scenarioId)?.weight
    const scenarioRestrictions = findScenarioById(scenarioId)?.restrictions || []
    const scenarioWeight = scenarioIdWeight || scenarioIdWeight === 0 ? scenarioIdWeight : defaultWeight
    const domain = window.location.hostname
    if (scenarioRestrictions.length > 0) {
      if (scenarioRestrictions.some((restriction) => domain.includes(restriction))) {
        for (let i = 0; i < scenarioWeight; i++) {
          scenarioIdCopies.push(scenarioId)
        }
      }
    } else {
      for (let i = 0; i < scenarioWeight; i++) {
        scenarioIdCopies.push(scenarioId)
      }
    }
  })
  return scenarioIdCopies[Math.floor(Math.random() * scenarioIdCopies.length)]
}

export const findPreviousUsedScenarioIdBasedOnType = (type: ScenarioType): string | null => {
  if (getCookie('scenarioRegistry')) {
    const scenarioRegistry = JSON.parse(getCookie('scenarioRegistry'))
    return scenarioRegistry[type] ? scenarioRegistry[type] : null
  }

  return null
}

export const registerScenarioIdByType = (type: ScenarioType, id: string) => {
  let scenarioRegistry: Partial<Record<ScenarioType, string>> = {}
  if (getCookie('scenarioRegistry')) {
    scenarioRegistry = JSON.parse(getCookie('scenarioRegistry'))
    scenarioRegistry[type] = id
  } else {
    scenarioRegistry[type] = id
  }
  setCookie('scenarioRegistry', JSON.stringify(scenarioRegistry))
}
